import { BaseRequestModel } from "./BaseModel/BaseRequestModel";

export class getPPRARules extends BaseRequestModel{
    ID:number
    OfficeID:number
    PPRARule:any
}